import './styles.css'

import { useCallback, useMemo } from 'react'

import { Flex, Text } from '@chakra-ui/react'
import { HideIcon, ShowIcon } from '@editor/assets/icons'
import { setIsVisible, setTransparency } from '@editor/pages/projects/common/SolidMeshManager/store'
import { RootState, useAppDispatch } from '@editor/store/app'
import { RangeInput } from '@infraloop/common'
import { useSelector } from 'react-redux'

import { setIsPointCloudInvisible, setPcdTransparency } from '../../store/blueprintEditor'

const PCDQuickControls = () => {
  const dispatch = useAppDispatch()
  const selectedBlueprint = useSelector((state: RootState) => state.blueprint.editor.selectedBlueprint)
  const isCreatingBlueprint = useSelector((state: RootState) => state.blueprint.editor.isCreatingBlueprint)
  const isPointCloudInvisible = useSelector((state: RootState) => state.blueprint.editor.isPointCloudInvisible)
  const pcdTransparency = useSelector((state: RootState) => state.blueprint.editor.pcdTransparency)
  const solidMeshTransparency = useSelector((state: RootState) => state.solidMesh.transparency)

  const transparency = useMemo(
    () => Math.max(pcdTransparency, solidMeshTransparency) * 100,
    [pcdTransparency, solidMeshTransparency],
  )

  const handleVisibilityToggle = () => {
    dispatch(setIsPointCloudInvisible(!isPointCloudInvisible))
    dispatch(setIsVisible(isPointCloudInvisible))
  }

  const handleOpacityChange = useCallback(
    (value: number) => {
      dispatch(setPcdTransparency(value / 100))
      dispatch(setTransparency(value / 100))
    },
    [dispatch],
  )

  // Only render when we have a selected blueprint and not creating
  if (!selectedBlueprint || isCreatingBlueprint) {
    return null
  }

  return (
    <Flex id="pcd-quick-controls" zIndex={20} alignItems="center" className={isPointCloudInvisible ? '' : 'active'}>
      <Flex onClick={handleVisibilityToggle} className="toggle" alignItems="center" cursor="pointer" gap={2}>
        {isPointCloudInvisible ? <HideIcon /> : <ShowIcon />}
        <Text>点群</Text>
      </Flex>
      <Flex className="range" ml={2}>
        <RangeInput
          colorPalette="black"
          testId="quickPcdTransparency"
          min={1}
          max={100}
          step={10}
          precision={0}
          value={transparency}
          displayValue={`${transparency}`}
          unit="%"
          updateValue={handleOpacityChange}
        />
      </Flex>
    </Flex>
  )
}

export default PCDQuickControls
